import { DateTime } from "luxon"
import * as util from "./util"
import Swal from "sweetalert2"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    if (window.location.pathname === "/onsite-contact") {
      util.amplitudeInit(instance, "Onsite Contact Page Viewed")
    } else if (window.location.pathname === "/guests") {
      util.amplitudeInit(instance, "Guests Page Viewed")
    } else if (window.location.pathname === "/create-guest-page") {
      util.amplitudeInit(instance, "Create Guest Page Viewed")
    } else if (window.location.pathname === "/recurring-admin") {
      util.amplitudeInit(instance, "Recurring Admin Page Viewed")
    } else if (window.location.pathname === "/cancel-session") {
      util.amplitudeInit(instance, "Booker Cancel Page Viewed")
    }
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    var searchParams = util.getSearchParams()

    function logAmplitudeEvent(eventName, eventProps) {
      let eventProperties = {}
      if (eventProps) {
        eventProperties = eventProps
      }
      try {
        eventProperties["id"] = searchParams.get("id")
      } catch (err) {}
      util.logAmplitudeEvent(eventName, eventProperties)
    }

    async function onsiteContactInit() {
      try {
        let id = searchParams.get("id")
        if (id) {
          try {
            const contactData = await util.api
              .get("get-onsite-contact?id=" + id, { retry: { limit: 4 } })
              .json()
            if (contactData.venue_email || contactData.venue_phone) {
              if (contactData.venue_email) {
                let venueEmail = document.getElementById("venue-email")
                venueEmail.href = "mailto:" + contactData.venue_email
                venueEmail.innerText = contactData.venue_email.toLowerCase()
              }
              if (contactData.venue_phone) {
                let venuePhone = document.getElementById("venue-phone")
                venuePhone.href = "tel:" + contactData.venue_phone
                venuePhone.innerText = contactData.venue_phone
              }
            } else {
              document.getElementById("venue-contacts").style.display = "none"
            }
            if (contactData.error) {
              document.getElementById("venue-contact-message").innerText =
                contactData.venue_name + " contact details:"
              document.getElementById("error-message").innerText =
                contactData.error
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("onsite-contact-content").style.display =
                "none"
              logAmplitudeEvent("Onsite Contact Error Shown", {
                error: contactData.error,
              })
            } else {
              if (contactData.valid_from_time) {
                document.getElementById("valid-times").innerHTML =
                  "You can call this number from <strong>" +
                  contactData.valid_from_time +
                  "</strong> to <strong>" +
                  contactData.valid_to_time +
                  "</strong>."
              }
              if (contactData.venue_name) {
                document.getElementById("venue-contact-message").innerText =
                  "If you need to contact " +
                  contactData.venue_name +
                  " outside those hours:"
                document.getElementById("phone-pretext").innerText =
                  "Your on-site contact for " + contactData.venue_name + " is:"
              }
              if (contactData.twilio_phone) {
                let onsiteLink = document.getElementById("onsite-link")
                onsiteLink.href = "tel:" + contactData.twilio_phone
                onsiteLink.innerText = contactData.twilio_phone_friendly
              }
              logAmplitudeEvent("Onsite Contact Shown")
            }
            document.getElementById("preloader-background").style.display =
              "none"
          } catch (err) {
            document.getElementById("error-message").innerHTML =
              'An error occurred while confirming the transaction. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("onsite-contact-content").style.display =
              "none"
            document.getElementById("preloader-background").style.display =
              "none"
            logAmplitudeEvent("Error During Onsite Contact", {
              error: err.toString(),
            })
          }
        } else {
          logAmplitudeEvent("Missing Onsite Contact Transaction ID")
          document.getElementById("onsite-contact-content").style.display =
            "none"
          document.getElementById("error-section").style.display = "flex"
          document.getElementById("preloader-background").style.display = "none"
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    async function guestInfoInit() {
      try {
        let id = searchParams.get("id")
        if (id) {
          try {
            const guestData = await util.api
              .get("get-guest-info?id=" + id, { retry: { limit: 4 } })
              .json()
            if (guestData.error) {
              document.getElementById("error-message").innerHTML = ""
              document.getElementById("error-message").innerText =
                guestData.error
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("guest-info").style.display = "none"
              logAmplitudeEvent("Guest Info Error Shown")
            } else if (guestData.first_name) {
              document.getElementById("hero-image").src = guestData.image_url
              let eventTitle = guestData.venue_name
              if (guestData.event_title) {
                eventTitle = guestData.event_title.trim()
              }
              if (
                eventTitle.slice(-1) === "." ||
                eventTitle.slice(-1) === "!" ||
                eventTitle.slice(-1) === "?"
              ) {
                document.getElementById("header-title").innerText = util
                  .capitaliseFirstLetter(eventTitle)
                  .slice(0, -1)
                document.getElementById("header-title-span").innerText =
                  eventTitle.slice(-1)
              } else {
                document.getElementById("header-title").innerText =
                  util.capitaliseFirstLetter(eventTitle)
              }
              document.getElementById("intro").innerText =
                util.capitaliseFirstLetter(guestData.first_name) +
                " has booked " +
                guestData.space_or_venue_name +
                " and can't wait to see you there!"
              document.getElementById("booking-date").innerText =
                "The venue is booked for " +
                guestData.event_date_string +
                " " +
                guestData.start_time +
                " - " +
                guestData.end_time +
                "."
              let arrivalTime = guestData.start_time
              let eventStart = guestData.event_datetime
              if (guestData.arrival_time) {
                arrivalTime = guestData.arrival_time
                eventStart = eventStart.slice(0, -5) + arrivalTime
              }
              if (guestData.arrival_time_end) {
                arrivalTime =
                  "between " + arrivalTime + " - " + guestData.arrival_time_end
              } else {
                arrivalTime = "at " + arrivalTime
              }
              document.getElementById("arrival-host").innerText =
                util.capitaliseFirstLetter(guestData.first_name)
              document.getElementById("arrival-time").innerText = arrivalTime
              document.getElementById("calendar-apple").href =
                "https://calndr.link/d/event/?service=apple&start=" +
                eventStart +
                "&end=" +
                guestData.event_end_datetime +
                "&timezone=Europe/London&location=" +
                guestData.address +
                "&title=" +
                guestData.space_name
              document.getElementById("calendar-google").href =
                "https://calndr.link/d/event/?service=google&start=" +
                eventStart +
                "&end=" +
                guestData.event_end_datetime +
                "&timezone=Europe/London&location=" +
                guestData.address +
                "&title=" +
                guestData.space_name
              document.getElementById("calendar-office365").href =
                "https://calndr.link/d/event/?service=office365&start=" +
                eventStart +
                "&end=" +
                guestData.event_end_datetime +
                "&timezone=Europe/London&location=" +
                guestData.address +
                "&title=" +
                guestData.space_name
              document.getElementById("calendar-outlook").href =
                "https://calndr.link/d/event/?service=outlook&start=" +
                eventStart +
                "&end=" +
                guestData.event_end_datetime +
                "&timezone=Europe/London&location=" +
                guestData.address +
                "&title=" +
                guestData.space_name
              document.getElementById("calendar-outlookcom").href =
                "https://calndr.link/d/event/?service=outlookcom&start=" +
                eventStart +
                "&end=" +
                guestData.event_end_datetime +
                "&timezone=Europe/London&location=" +
                guestData.address +
                "&title=" +
                guestData.space_name
              document.getElementById("calendar-yahoo").href =
                "https://calndr.link/d/event/?service=yahoo&start=" +
                eventStart +
                "&end=" +
                guestData.event_end_datetime +
                "&timezone=Europe/London&location=" +
                guestData.address +
                "&title=" +
                guestData.space_name

              document.getElementById("map-image").src =
                "https://maps.googleapis.com/maps/api/staticmap?center=" +
                guestData.latitude.toString() +
                "," +
                guestData.longitude.toString() +
                "&zoom=14&size=640x320&scale=2&key=AIzaSyA9J3K_nqNOmRP-DRBzHdr7mpXF9nVXi7s&map_id=2e416890e2e3f59e&markers=scale:1|anchor:center|icon:https://assets-global.website-files.com/5f5f7fb0593ba84e85cb2ac4/63d8f189ef91321e047ed602_Sharesy%20Favicon.png|" +
                guestData.latitude.toString() +
                "," +
                guestData.longitude.toString()
              document.getElementById("address").innerText = guestData.address
              document.getElementById("map-link").href =
                "https://www.google.com/maps/search/?api=1&query=" +
                guestData.latitude.toString() +
                "%2C" +
                guestData.longitude.toString()
              if (guestData.virtual_tour) {
                document.getElementById("virtual-tour-link").href =
                  guestData.space_url + "#youtube-header"
              } else {
                document.getElementById("virtual-tour-message").style.display =
                  "none"
              }
              if (guestData.parking && guestData.parking.length > 0) {
                let parkingHtml = "<ul>"
                guestData.parking.forEach((park) => {
                  parkingHtml += "<li>" + park.value + "</li>"
                })
                parkingHtml += "</ul>"
                document.getElementById("parking").innerHTML = parkingHtml
              } else {
                document.getElementById("by-car").style.display = "none"
              }
              if (guestData.promo) {
                document.getElementById("promo-code").innerText =
                  guestData.promo
                document.getElementById("promo-name").innerText =
                  util.capitaliseFirstLetter(guestData.first_name)
              } else {
                document.getElementById("promo-section").classList.add("hide")
              }
              logAmplitudeEvent("Guest Info Viewed", {
                ID: guestData.id,
                Promo: guestData.promo,
              })
            } else {
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("guest-info").style.display = "none"
            }
            document.getElementById("preloader-background").style.display =
              "none"
          } catch (err) {
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("guest-info").style.display = "none"
            document.getElementById("preloader-background").style.display =
              "none"
            logAmplitudeEvent("Error During Guest Info", {
              error: err.toString(),
            })
          }
        } else {
          logAmplitudeEvent("Missing Guest Info Transaction ID")
          document.getElementById("guest-info").style.display = "none"
          document.getElementById("error-section").style.display = "flex"
          document.getElementById("preloader-background").style.display = "none"
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    async function setGuestInfo() {
      let id = searchParams.get("id")
      let jsonBody = {
        id: id,
        arrival_time: document.getElementById("arrival-time").value,
      }
      if (document.getElementById("arrival-time-end").value) {
        jsonBody.arrival_time_end =
          document.getElementById("arrival-time-end").value
      }
      if (document.getElementById("event-title").value) {
        jsonBody.event_title = document.getElementById("event-title").value
      }
      try {
        const setGuestData = await util.api
          .post("set-guest-info", {
            json: jsonBody,
            retry: { limit: 4 },
          })
          .json()
        if (setGuestData.guest_info_url) {
          logAmplitudeEvent("Set Guest Info Succeeded")
          document.getElementById("success-message").classList.remove("hide")
          document.getElementById("success-link").href =
            setGuestData.guest_info_url
          document.getElementById("success-link").innerText =
            setGuestData.guest_info_url
          document.getElementById("submit-button").value =
            "Update guest info page"
        }
      } catch (err) {
        document.getElementById("error-message").innerHTML =
          'An error occurred while getting your guest info page. Please try again later or contact us: <a href="mailto:help@sharesy.com" class="link-red">help@sharesy.com</a>.'
        document.getElementById("error-section").style.display = "flex"
        logAmplitudeEvent("Error Attempting Set Guest Info", {
          error: err.toString(),
        })
      }
    }

    function arrivalTimeUpdate() {
      let arrivalTime = document.getElementById("arrival-time")
      let arrivalTimeEnd = document.getElementById("arrival-time-end")
      if (!arrivalTime.value) {
        logAmplitudeEvent("Arrival Time Must Be Entered")
        arrivalTime.setCustomValidity(
          "You must enter a time when your guests should arrive"
        )
      } else {
        arrivalTime.setCustomValidity("")
      }
      if (arrivalTimeEnd.value && arrivalTimeEnd.value <= arrivalTime.value) {
        logAmplitudeEvent("Arrival Time End Before Arrival Time")
        arrivalTimeEnd.setCustomValidity(
          "The latest arrival time can't be before the arrival time"
        )
      } else {
        arrivalTimeEnd.setCustomValidity("")
      }

      if (arrivalTimeEnd.value) {
        document.getElementById("arrival-message").innerText =
          'Guests will see "Your host has asked that you arrive between ' +
          arrivalTime.value +
          " - " +
          arrivalTimeEnd.value +
          '".'
      } else {
        document.getElementById("arrival-message").innerText =
          'Guests will see "Your host has asked that you arrive at ' +
          arrivalTime.value +
          '".'
      }
    }

    async function createGuestInfoInit() {
      try {
        let id = searchParams.get("id")
        if (id) {
          try {
            const contactData = await util.api
              .get("create-guest-info?id=" + id, { retry: { limit: 4 } })
              .json()
            if (contactData.error) {
              document.getElementById("error-message").innerHTML = ""
              document.getElementById("error-message").innerText =
                contactData.error
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("guest-info").style.display = "none"
              logAmplitudeEvent("Create Guest Info Error Shown")
            } else if (contactData.arrival_time) {
              document
                .getElementById("arrival-time")
                .addEventListener("input", function (e) {
                  arrivalTimeUpdate()
                })
              document
                .getElementById("arrival-time-end")
                .addEventListener("input", function (e) {
                  arrivalTimeUpdate()
                })
              if (navigator.share) {
                let shareButton = document.getElementById("share")
                shareButton.classList.remove("hide")
                shareButton.addEventListener("click", function (e) {
                  let title = "Event at " + contactData.venue_name
                  if (document.getElementById("event-title").value) {
                    title = document.getElementById("event-title").value
                  }
                  navigator.share({
                    title: title,
                    url: document.getElementById("success-link").href,
                  })
                  logAmplitudeEvent("Guest Info Mobile Share")
                })
              }
              document
                .getElementById("submit-button")
                .addEventListener("click", function (e) {
                  e.preventDefault()
                  let createInfoPageForm =
                    document.getElementById("create-info-page")
                  if (createInfoPageForm.checkValidity()) {
                    document.getElementById("error-section").style.display =
                      "none"
                    let button = document.getElementById("submit-button")
                    let buttonText = button.value
                    button.value = "Please wait..."
                    button.disabled = true
                    setGuestInfo()
                    button.disabled = false
                    button.value = buttonText
                  } else {
                    createInfoPageForm.reportValidity()
                    logAmplitudeEvent("Set Guest Info Form Not Valid")
                  }
                })

              document.getElementById("arrival-time").value =
                contactData.arrival_time
              if (contactData.arrival_time_end) {
                document.getElementById("arrival-time-end").value =
                  contactData.arrival_time_end
              }
              arrivalTimeUpdate()
              if (contactData.event_title) {
                document.getElementById("event-title").value =
                  contactData.event_title
              }
              let src = null
              try {
                src = searchParams.get("src")
              } catch (err) {}
              logAmplitudeEvent("Create Guest Info Viewed", {
                ID: contactData.id,
                Source: src,
              })
            } else {
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("guest-info").style.display = "none"
            }
            document.getElementById("preloader-background").style.display =
              "none"
          } catch (err) {
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("guest-info").style.display = "none"
            document.getElementById("preloader-background").style.display =
              "none"
            logAmplitudeEvent("Error During Create Guest Info", {
              error: err.toString(),
            })
          }
        } else {
          logAmplitudeEvent("Missing Create Guest Info Transaction ID")
          document.getElementById("guest-info").style.display = "none"
          document.getElementById("error-section").style.display = "flex"
          document.getElementById("preloader-background").style.display = "none"
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    function getStripeCustomerPortalLink(email) {
      return `https://checkout.sharesy.com/p/login/8wM2aO3IRdg366A3cc?prefilled_email=${encodeURIComponent(
        email
      )}`
    }

    async function recurringAdminInit() {
      try {
        let id = searchParams.get("id")
        if (id) {
          try {
            let data = await util.api
              .get("recurring-admin?id=" + id, {
                retry: { limit: 4 },
              })
              .json()
            if (data.error) {
              document.getElementById("error-message").innerHTML = ""
              document.getElementById("error-message").innerText = data.error
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("recurring-admin").style.display = "none"
              logAmplitudeEvent("Recurring Admin Error Shown")
            } else if (data.sessions) {
              document.getElementById("customer-portal-link").href =
                getStripeCustomerPortalLink(data.invoice_email)
              document.getElementById("customer-portal-link-opt-out").href =
                getStripeCustomerPortalLink(data.invoice_email)
              let firstOne = null
              if (data.sessions.length > 0) {
                document.getElementById("next-book-date-top").innerText =
                  data.next_book_date_string
                document.getElementById("next-book-date-bottom").innerText =
                  data.next_book_date_string
                if (data.description) {
                  document.getElementById("session-description").innerText =
                    "your " + data.description + " sessions"
                }
                document.getElementById("scheduling-period").innerText =
                  data.scheduling_period

                // either ... we will send "you an invoice"
                // or     ... we will send "an invoice to abc@email.com"
                if (data.invoice_email_is_different) {
                  document.getElementById(
                    "invoice-sent-to-text"
                  ).innerText = `an invoice to ${data.invoice_email}`
                }

                updateSessionTotals(data.num_sessions, data.total_price)
                if (data.bacs_debit_last4) {
                  document.getElementById(
                    "payment-description-variation"
                  ).innerText = "and charge"
                  document
                    .getElementById("direct-debit-remove")
                    .classList.remove("hide")
                  document
                    .getElementById("direct-debit-add")
                    .classList.add("hide")
                  document.getElementById(
                    "payment-message-end"
                  ).innerText = ` to the direct debit set up for bank account ending ${data.bacs_debit_last4}`
                  document.getElementById("default-card").classList.add("hide")
                  document
                    .getElementById("card-opt-out-block")
                    .classList.add("hide")
                } else if (data.card_brand) {
                  document.getElementById(
                    "payment-description-variation"
                  ).innerText = "and automatically charge"
                  document.getElementById("card-brand").innerText =
                    data.card_brand
                  document.getElementById("card-last4").innerText =
                    data.card_last4
                  document.getElementById("card-last4-opt-out").innerText =
                    data.card_last4
                  if (data.card_brand.toLowerCase() === "mastercard") {
                    document
                      .getElementById("mastercard")
                      .classList.remove("hide")
                  } else if (data.card_brand.toLowerCase() === "visa") {
                    document.getElementById("visa").classList.remove("hide")
                  } else if (
                    data.card_brand.toLowerCase() === "american express" ||
                    data.card_brand.toLowerCase() === "amex"
                  ) {
                    document.getElementById("amex").classList.remove("hide")
                  }
                } else {
                  document.getElementById(
                    "payment-description-variation"
                  ).innerText = "for"
                  document
                    .getElementById("payment-message-end")
                    .classList.add("hide")
                  document.getElementById("default-card").classList.add("hide")
                  if (data.auto_payment_opt_out) {
                    // When auto_payment_opt_out is set we ignore cards they add, so no
                    // point advertising that they can add new cards to the Stripe portal
                    document
                      .getElementById("add-another-payment-method")
                      .classList.add("hide")
                  }
                  document
                    .getElementById("card-opt-out-block")
                    .classList.add("hide")
                }
                firstOne = true
                data.sessions.forEach((element) => {
                  addRecurringSessionItem(
                    element,
                    document.getElementById("sessions"),
                    !data.cancelled,
                    !firstOne,
                    id
                  )
                  firstOne = false
                })
                let cardOptOut = document.getElementById("card-opt-out")
                cardOptOut.addEventListener("click", async function (e) {
                  e.preventDefault()
                  document.getElementById("modal-background").style.display =
                    "flex"
                  try {
                    const data = await util.api
                      .post("auto-payment-opt-out", {
                        json: {
                          id: id,
                        },
                        retry: { limit: 0 },
                      })
                      .json()
                    if (data.success) {
                      logAmplitudeEvent("Auto Payment Opt Out")
                      window.location.reload()
                      return
                    } else {
                      document.getElementById("recurring-admin").style.display =
                        "none"
                      document.getElementById("error-section").style.display =
                        "flex"
                      document.getElementById("error-message").innerHTML =
                        'An error occurred while changing your payment method. Please refresh and try again - if you get the same error please contact <a href="mailto:help@sharesy.com" class="link-red">help@sharesy.com</a>.'
                      document.getElementById(
                        "modal-background"
                      ).style.display = "none"
                      logAmplitudeEvent("Error During Auto Payment Opt Out")
                    }
                  } catch (err) {
                    document.getElementById("recurring-admin").style.display =
                      "none"
                    document.getElementById("error-section").style.display =
                      "flex"
                    document.getElementById("error-message").innerHTML =
                      'An error occurred while changing your payment method. Please refresh and try again - if you get the same error please contact <a href="mailto:help@sharesy.com" class="link-red">help@sharesy.com</a>.'
                    document.getElementById("modal-background").style.display =
                      "none"
                    logAmplitudeEvent("Error During Auto Payment Opt Out", {
                      error: err.toString(),
                    })
                  }
                })
              } else {
                document.getElementById(
                  "sessions-description"
                ).innerText = `For the next billing period starting ${data.next_billing_start_date_string} we will not book any of your regular sessions.`
                document.getElementById("sessions").classList.add("hide")
                document.getElementById("payment-section").classList.add("hide")
                document
                  .getElementById("questions-section")
                  .classList.add("hide")
              }

              if (data.cancelled) {
                document
                  .getElementById("cancelled-error")
                  .classList.remove("hide")
                document
                  .getElementById("customer-portal-link")
                  .classList.add("hide")
                document
                  .getElementById("card-opt-out-block")
                  .classList.add("hide")
              }

              if (data.future_exclusions.length > 0) {
                firstOne = true
                data.future_exclusions.forEach((item) => {
                  addRecurringExclusionItem(
                    item,
                    document.getElementById("removed-sessions"),
                    !data.cancelled,
                    !firstOne,
                    id
                  )
                  firstOne = false
                })
              }

              let futureSessions = document.getElementById("future-sessions")
              firstOne = true
              data.future_sessions.forEach((item) => {
                addRecurringSessionItem(
                  item,
                  futureSessions,
                  !data.cancelled,
                  !firstOne,
                  id
                )
                firstOne = false
              })

              let viewFutureSessions = document.getElementById(
                "view-future-sessions"
              )
              if (futureSessions.offsetHeight <= 220) {
                viewFutureSessions.classList.add("hide")
              } else {
                futureSessions.classList.add("hide-and-fade")

                viewFutureSessions.addEventListener("click", function (e) {
                  e.preventDefault()
                  futureSessions.classList.remove("hide-and-fade")
                  viewFutureSessions.classList.add("hide")
                  logAmplitudeEvent("View Future Recurring Sessions")
                })
              }

              let src = null
              try {
                src = searchParams.get("src")
              } catch (err) {}
              logAmplitudeEvent("Recurring Admin Viewed", {
                ID: data.id,
                Source: src,
              })
            } else {
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("recurring-admin").style.display = "none"
              logAmplitudeEvent("Recurring Admin No Sessions")
            }
            document
              .getElementById("preloader-background")
              .classList.add("hide")
          } catch (err) {
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("recurring-admin").style.display = "none"
            document
              .getElementById("preloader-background")
              .classList.add("hide")
            logAmplitudeEvent("Error During Recurring Admin", {
              error: err.toString(),
            })
            util.logToSentry(err)
          }
        } else {
          logAmplitudeEvent("Missing Recurring Admin Transaction ID")
          document.getElementById("recurring-admin").style.display = "none"
          document.getElementById("error-section").style.display = "flex"
          document.getElementById("preloader-background").classList.add("hide")
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    /**
     * Add a recurring session item to the UI. This is called for each session returned
     * by the API.
     * @param item The session item to add.
     * @param parentElement The parent div to add it to.
     * @param includeRemoveLink Whether a link should be added to remove the session.
     * @param addTopMargin Whether top margin should be added (don't add to the first item).
     * @param id The ID for the recurring booking.
     */
    function addRecurringSessionItem(
      item,
      parentElement,
      includeRemoveLink,
      addTopMargin,
      id
    ) {
      let sessionItem = document.createElement("li")
      if (addTopMargin) {
        sessionItem.style.marginTop = "16px"
      }
      let divLine1 = document.createElement("div")
      divLine1.innerHTML =
        item.event_date_string +
        " " +
        item.start_time_local +
        " - " +
        item.end_time_local +
        '<span style="margin-left:10px; margin-right:10px; font-weight:700">·</span>£<span class="session-price">' +
        parseFloat(item.price).toFixed(2) +
        "</span>"
      sessionItem.appendChild(divLine1)
      let divLine2 = document.createElement("div")
      divLine2.innerText = item.type
      sessionItem.appendChild(divLine2)
      if (includeRemoveLink) {
        let removeLink = document.createElement("a")
        removeLink.innerText = "Remove this session"
        removeLink.href = "#"
        removeLink.addEventListener("click", async function (e) {
          e.preventDefault()
          let removeSessionLink = e.currentTarget
          document.getElementById("modal-background").style.display = "flex"
          let event_datetime_string = DateTime.fromISO(item.event_datetime, {
            zone: util.TIMEZONE,
          }).toISO()
          let event_end_datetime_string = DateTime.fromISO(
            item.event_datetime.replace(
              item.start_time_local,
              item.end_time_local
            ),
            { zone: util.TIMEZONE }
          ).toISO()
          try {
            const data = await util.api
              .post("add-recurring-exclusion", {
                json: {
                  id: id,
                  event_datetime_string: event_datetime_string,
                  event_end_datetime_string: event_end_datetime_string,
                  type_id: item.type_id,
                  type: item.type,
                  space_id: item.space_id,
                },
                retry: { limit: 0 },
              })
              .json()
            if (data.success) {
              if (parentElement.childElementCount === 1) {
                window.location.reload()
              }
              let sessionPrice =
                removeSessionLink.parentElement.getElementsByClassName(
                  "session-price"
                )[0].innerText
              if (parentElement.id === "sessions") {
                updateSessionTotals(-1, -1 * sessionPrice)
              }
              removeSessionLink.parentElement.remove()
              document.getElementById("modal-background").style.display = "none"
              logAmplitudeEvent("Add Recurring Exclusion", {
                Type:
                  parentElement.id === "future-sessions" ? "Future" : "Next",
                Times: `${event_datetime_string} - ${event_end_datetime_string}`,
              })
              let removedSessions = document.getElementById("removed-sessions")
              let newItem = item
              item.id = data.id
              addRecurringExclusionItem(
                newItem,
                removedSessions,
                true,
                removedSessions.childElementCount > 0,
                id
              )
            } else {
              document.getElementById("recurring-admin").style.display = "none"
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("error-message").innerHTML =
                'An error occurred while removing the session. Please refresh and try again - if you get the same error please contact <a href="mailto:help@sharesy.com" class="link-red">help@sharesy.com</a>.'
              document.getElementById("modal-background").style.display = "none"
              logAmplitudeEvent("Error During Add Recurring Exclusion")
            }
          } catch (err) {
            document.getElementById("recurring-admin").style.display = "none"
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("error-message").innerHTML =
              'An error occurred while removing the session. Please refresh and try again - if you get the same error please contact <a href="mailto:help@sharesy.com" class="link-red">help@sharesy.com</a>.'
            document.getElementById("modal-background").style.display = "none"
            logAmplitudeEvent("Error During Add Recurring Exclusion", {
              error: err.toString(),
            })
          }
        })
        sessionItem.appendChild(removeLink)
      }
      parentElement.appendChild(sessionItem)
    }

    /**
     * Add a recurring exclusion item to the UI.
     * @param item The exclusion item to add.
     * @param parentElement The parent div to add it to.
     * @param includeLink Whether a link should be added to undo the exclusion.
     * @param addTopMargin Whether top margin should be added (don't add to the first item).
     * @param id The ID for the recurring booking.
     */
    function addRecurringExclusionItem(
      item,
      parentElement,
      includeRemoveLink,
      addTopMargin,
      id
    ) {
      let sessionItem = document.createElement("li")
      if (addTopMargin) {
        sessionItem.style.marginTop = "16px"
      }
      let divLine1 = document.createElement("div")
      divLine1.innerText =
        item.event_date_string +
        " " +
        item.start_time_local +
        " - " +
        item.end_time_local
      sessionItem.appendChild(divLine1)
      let divLine2 = document.createElement("div")
      divLine2.innerText = item.type
      sessionItem.appendChild(divLine2)
      if (includeRemoveLink) {
        let removeLink = document.createElement("a")
        removeLink.innerText = "Keep this future session"
        removeLink.href = "#"
        removeLink.dataset.exclusionId = item.id
        removeLink.addEventListener("click", async function (e) {
          e.preventDefault()
          let removeExclusionLink = e.currentTarget
          document.getElementById("modal-background").style.display = "flex"
          try {
            const data = await util.api
              .post("delete-recurring-exclusion", {
                json: {
                  id: id,
                  recurring_exclusion_id: parseInt(
                    removeExclusionLink.dataset.exclusionId
                  ),
                },
                retry: { limit: 0 },
              })
              .json()
            if (data.success) {
              logAmplitudeEvent("Remove Recurring Exclusion", {
                ExclusionID: removeExclusionLink.dataset.exclusionId,
              })
              document.location.reload()
            } else {
              document.getElementById("recurring-admin").style.display = "none"
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("error-message").innerHTML =
                'An error occurred while adding the future session. Please refresh and try again - if you get the same error please contact <a href="mailto:help@sharesy.com" class="link-red">help@sharesy.com</a>.'
              document.getElementById("modal-background").style.display = "none"
              logAmplitudeEvent("Error During Remove Recurring Exclusion")
            }
          } catch (err) {
            document.getElementById("recurring-admin").style.display = "none"
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("error-message").innerHTML =
              'An error occurred while adding the future session. Please refresh and try again - if you get the same error please contact <a href="mailto:help@sharesy.com" class="link-red">help@sharesy.com</a>.'
            document.getElementById("modal-background").style.display = "none"
            logAmplitudeEvent("Error During Remove Recurring Exclusion", {
              error: err.toString(),
            })
          }
        })
        sessionItem.appendChild(removeLink)
      }
      parentElement.appendChild(sessionItem)
      document
        .getElementById("removed-session-section")
        .classList.remove("hide")
    }

    function updateSessionTotals(sessionDiff, priceDiff) {
      let numSessions = parseInt(
        document.getElementById("num-sessions").innerText
      )
      let totalPrice = parseFloat(
        document.getElementById("total-price-top").innerText
      )
      numSessions += parseInt(sessionDiff)
      totalPrice += parseFloat(priceDiff)
      document.getElementById("num-sessions").innerText = numSessions
      document.getElementById("total-price-top").innerText =
        totalPrice.toFixed(2)
      document.getElementById("total-price-bottom").innerText =
        totalPrice.toFixed(2)
    }

    async function bookerCancelInit() {
      let sessionData
      try {
        sessionData = await util.api
          .get(`get-session-detail-id?id=${searchParams.get("id")}`)
          .json()
      } catch (err) {
        util.logToSentry(err)
        util.logAmplitudeEvent("Unknown Error Retrieving Session Detail")
        document.getElementById("error-message").innerText =
          "Error finding the booking. Please email us (help@sharesy.com) if you keep seeing this error."
        document.getElementById("error-section").style.display = "flex"
        document.getElementById("preloader-background").classList.add("hide")
      }
      try {
        document.getElementById("booker-name").innerText =
          sessionData.booking.first_name + " " + sessionData.booking.last_name
        document.getElementById("space").innerText = sessionData.space_name
        let startDateTime = DateTime.fromISO(
          sessionData.event_start_utc
        ).setZone(util.TIMEZONE)
        let endDateTime = DateTime.fromISO(sessionData.event_end_utc).setZone(
          util.TIMEZONE
        )
        document.getElementById("times").innerText =
          startDateTime.toFormat("ccc dd LLL yyyy HH:mm") +
          " - " +
          endDateTime.toFormat("HH:mm")
        document.getElementById("hire-duration").innerText =
          "Hire - " + util.timeDiffHoursMins(startDateTime, endDateTime)
        document.getElementById("session-price").innerText =
          "£" + sessionData.price
        document.getElementById("total-price").innerText =
          "£" + sessionData.total_price
        let addonContainer = document.getElementById("addon-container")
        if (sessionData.addons.length > 0) {
          sessionData.addons.forEach((addon) => {
            let addonDiv = document.createElement("div")
            addonDiv.classList.add("price-element")
            let addonNameDiv = document.createElement("div")
            addonNameDiv.innerText = addon.name
            addonDiv.appendChild(addonNameDiv)
            let addonPriceDiv = document.createElement("div")
            addonPriceDiv.innerText =
              "£" + parseFloat(addon.total_price).toFixed(2)
            addonDiv.appendChild(addonPriceDiv)
            addonContainer.appendChild(addonDiv)
          })
          addonContainer.classList.remove("hide")
        }
        if (sessionData.discount > 0) {
          document.getElementById("promo").innerText =
            "Promo (" + sessionData.booking.promo_code + ")"
          document.getElementById("discount").innerText =
            "-£" + sessionData.discount
          document.getElementById("discount-section").classList.remove("hide")
          if (sessionData.addons.length > 0) {
            // Only display subtotal when there are addons and a promo code
            document.getElementById("subtotal").innerText =
              "£" + sessionData.total_original
            document.getElementById("subtotal-section").classList.remove("hide")
          }
        }

        /* Cases:
        - Session already cancelled
            just status; no buttons
        - Venue has custom cancellation policy
            red message; one or no buttons, depeding on whether can reschedule
        - Are still able to cancel
            message; both buttons
        - Too late to cancel, but can still reschedule
            red message; one button
        - Too late to cancel or reschedule (maybe a past booking)
            red message; no buttons
        */
        let showCancel = false
        let showReschedule = false
        if (sessionData.status_code == "cancelled") {
          document.getElementById("status").innerText = "Booking cancelled"
          document.getElementById("status").classList.add("red")
        } else if (sessionData.custom_cancellation_policy) {
          document.getElementById("status").innerText =
            "This venue has their own custom cancellation policy - if you wish to cancel first check you are within the cancellation period (it is shown at checkout for this venue) then email help@sharesy.com"
          document.getElementById("status").classList.add("red")
          if (DateTime.fromISO(sessionData.reschedule_by) > DateTime.now()) {
            showReschedule = true
          }
        } else if (DateTime.fromISO(sessionData.cancel_by) > DateTime.now()) {
          document.getElementById("status").innerText =
            sessionData.cancel_by_message
          showCancel = true
          showReschedule = true
        } else if (
          DateTime.fromISO(sessionData.reschedule_by) > DateTime.now()
        ) {
          document.getElementById("status").innerHTML =
            "<span class='red'>" +
            sessionData.cancel_by_message +
            "</span> You can still reschedule this session."
          showReschedule = true
        } else {
          document.getElementById("status").innerHTML =
            sessionData.cancel_by_message
          document.getElementById("status").classList.add("red")
        }

        if (showCancel) {
          let cancelButton = document.getElementById("cancel-button")
          cancelButton.addEventListener("click", async function (e) {
            e.preventDefault()

            const { value: cancelReason } = await Swal.fire({
              input: "textarea",
              title: "Why do you want to cancel?",
              inputPlaceholder: "Briefly explain why you are cancelling",
              inputAttributes: {
                "aria-label": "Explain why you are cancelling",
              },
              confirmButtonText: "Cancel booking",
              confirmButtonColor: "#1aa979",
              showCancelButton: true,
              cancelButtonText: "Close",
              cancelButtonColor: "#a3a3a3",
              reverseButtons: true,
              customClass: {
                popup: "swal-custom-popup",
                title: "swal-custom-title",
                confirmButton: "swal-custom-button",
                cancelButton: "swal-custom-button",
              },
              inputValidator: (value) => {
                if (!value) {
                  return "You need to enter a reason for cancelling"
                }
              },
            })
            if (cancelReason) {
              cancelButton.disabled = true
              cancelButton.value = "Please wait..."
              try {
                const data = await util.api
                  .post("cancel-session-booker", {
                    json: {
                      id: searchParams.get("id"),
                      reason: cancelReason,
                    },
                    retry: { limit: 0 },
                  })
                  .json()
                if (data.success) {
                  util.logAmplitudeEvent("Session Cancelled", {
                    session_id: session.session_id,
                    refunded: data.refunded,
                  })
                  if (data.refunded) {
                    document
                      .getElementById("success-message")
                      .classList.remove("hide")
                  } else {
                    document.getElementById("error-message").innerText =
                      "Your booking was cancelled but the refund has not completed. The Sharesy team have been notified - if you should have received a refund they will be in touch shortly."
                    document.getElementById("error-section").style.display =
                      "flex"
                  }
                  document.getElementById("change-button").classList.add("hide")
                } else {
                  document.getElementById("error-message").innerText =
                    data.reason
                      ? data.reason
                      : "The cancellation failed. Please refresh the page and try again. If you get the same error please email help@sharesy.com"
                  document.getElementById("error-section").style.display =
                    "flex"
                }
                cancelButton.classList.add("hide")
              } catch (err) {
                document.getElementById("error-message").innerText =
                  "The cancellation failed. Please refresh the page and try again. If you get the same error please email help@sharesy.com"
                document.getElementById("error-section").style.display = "flex"
                util.logToSentry(err)
                util.logAmplitudeEvent(
                  "Unknown Error During Booker Cancellation",
                  {
                    session_id: session.session_id,
                  }
                )
              }
            }
          })
          cancelButton.classList.remove("hide")
        }
        if (showReschedule) {
          let changeButton = document.getElementById("change-button")
          changeButton.href = "/change-booking?id=" + searchParams.get("id")
          changeButton.classList.remove("hide")
        }
        document.getElementById("preloader-background").classList.add("hide")
      } catch (err) {
        util.logToSentry(err)
      }
    }

    function init() {
      if (window.location.pathname === "/onsite-contact") {
        onsiteContactInit()
      } else if (window.location.pathname === "/guests") {
        guestInfoInit()
      } else if (window.location.pathname === "/create-guest-page") {
        createGuestInfoInit()
      } else if (window.location.pathname === "/recurring-admin") {
        recurringAdminInit()
      } else if (window.location.pathname === "/cancel-session") {
        bookerCancelInit()
      } else {
        console.error("Unknown page")
      }
    }

    return {
      init: init,
      logAmplitudeEvent: logAmplitudeEvent,
    }
  })()
}
